import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";

function getWhatsNextToolkitUrl(localeCode: LocaleCode): string | undefined {
  return getLocaleMetadata(localeCode).country.whatsNextToolkitUrl ?? undefined;
}

export { getWhatsNextToolkitUrl };
